import HomePage from '@/views/Home'
import LanguageLayout from '@/layout/languageLayout'
import Icon from '@ant-design/icons'
import { Navigate, RouteObject } from 'react-router-dom'

/* 菜单图表 */
import ICON_HOME from '@/assets/image/menu/home.svg?react'
import ICON_VALIDATOR from '@/assets/image/menu/validator.svg?react'
import { i18nConfig } from '@/i18n/config.js'
import { langRouterLangMap } from '@/i18n/lang'
import Verifynodes from '@/views/Verifynodes'
import ValidatorsDetailNew from '@/views/Verifynodes/detail'
import BlockChain from '@/views/BlockChain'
import BlockChainDetail from '@/views/BlockChain/detail/detail'
import Transaction from '@/views/Transaction'
import TransactionDetail from '@/views/Transaction/detail/detailIndex'
import TransactionAccountDetail from '@/views/Transaction/accontDetail/detail'
import TransactionModuleAccount from '@/views/Transaction/moduleAccount/detail'
import Rollup from '@/views/Rollup'
import RollupDetail from '@/views/Rollup/detail/index'
import RollupSigninTransaction from '@/views/Rollup/signinTransaction'
import RollupUpdateStateList from '@/views/Rollup/rollupUpdateStateList/index'
import CountryRegion from '@/views/CountryRegion'
import CountryRegionDetail from '@/views/CountryRegion/detail/index'
import Proposal from '@/views/Proposal/index'
import ProposalDetail from '@/views/Proposal/detail'
import AddressPublicity from '@/views/AddressPublicity/index'
import { UserHomeProvider } from '@/hoxStore/homeStore'

export type MetaProps = {
  title?: string
  isHidden?: boolean
  icon?: React.ReactNode
  redirectUrl?: string
  breadcrumb?: boolean
}

export type RouteObjectWithMeta = RouteObject & {
  meta?: MetaProps
  children?: RouteObjectWithMeta[]
}

/**
 * 路由前缀 H5 模式语言标识
 */
const ROUTER_PREFIX = '/:routerLang'

export const appRoutes: RouteObjectWithMeta[] = [
  /**
   * Rollup Rollup列表
   */
  // {
  //   path: `${ROUTER_PREFIX}/rollup`,
  //   children: [
  //     {
  //       path: '',
  //       index: true,
  //       element: <Rollup />,
  //       meta: {
  //         title: 'explorer_6',
  //         isHidden: false,
  //         icon: <Icon component={ICON_VALIDATOR} />,
  //       },
  //     },
  //     {
  //       path: 'updatestatetaillist',
  //       element: <RollupUpdateStateList />,
  //       meta: {
  //         title: 'explorer_10',
  //         isHidden: true,
  //         breadcrumb: true,
  //       },
  //     },
  //     {
  //       /** 签到交易列表 */
  //       path: 'signinTransactionList',
  //       element: <RollupSigninTransaction />,
  //       meta: {
  //         title: 'explorer_10',
  //         isHidden: true,
  //         breadcrumb: true,
  //       },
  //     },
  //     {
  //       path: ':dynamic',
  //       element: <RollupDetail />,
  //       meta: {
  //         title: 'explorer_10',
  //         isHidden: true,
  //         breadcrumb: true,
  //       },
  //     },
  //   ],
  // },
  /**
   * 普通账户详情
   */
  {
    path: `${ROUTER_PREFIX}/accountDetail`,
    meta: {
      title: 'explorer_10',
      isHidden: true,
      breadcrumb: true,
    },
    children: [
      {
        path: ':address',
        index: true,
        element: <TransactionAccountDetail />,
        meta: {
          title: 'explorer_334',
          isHidden: true,
          breadcrumb: false,
        },
      },
    ],
  },
  /**
   * 模块账户详情
   */
  {
    path: `${ROUTER_PREFIX}/moduleAccount`,
    meta: {
      // 模块账户详情
      title: 'explorer_10',
      isHidden: true,
      breadcrumb: true,
    },
    children: [
      {
        path: ':address',
        index: true,
        element: <TransactionModuleAccount />,
        meta: {
          title: 'explorer_334',
          isHidden: true,
          breadcrumb: false,
        },
      },
    ],
  },
  /**
   * 交易列表 /transaction
   * 交易详情  /transaction/:dynamic
   */
  {
    path: `${ROUTER_PREFIX}/transaction`,
    children: [
      {
        path: '',
        index: true,
        element: <Transaction />,
        meta: {
          //验证节点
          title: 'explorer_6',
          isHidden: false,
          icon: <Icon component={ICON_VALIDATOR} />,
        },
      },
      {
        path: ':dynamic',
        element: <TransactionDetail />,
        meta: {
          // 交易详情
          title: 'explorer_10',
          isHidden: true,
          breadcrumb: true,
        },
      },
    ],
  },
  /**
   * 区块 /blockchain
   * 区块详情 /blockchain/:dynamic 区块详情
   *
   */
  {
    path: `${ROUTER_PREFIX}/blockchain`,
    children: [
      {
        path: '',
        index: true,
        element: <BlockChain />,
        meta: {
          title: 'explorer_6',
          isHidden: false,
          icon: <Icon component={ICON_VALIDATOR} />,
        },
      },
      {
        path: ':dynamic',
        element: <BlockChainDetail />,
        meta: {
          title: 'explorer_10',
          isHidden: true,
          breadcrumb: true,
        },
      },
    ],
  },
  /**
   * 验证节点 /verifynodes
   * 验证节点详情 /verifynodes/:dynamic
   */
  // {
  //   path: `${ROUTER_PREFIX}/verifynodes`,
  //   children: [
  //     {
  //       path: '',
  //       index: true,
  //       element: <Verifynodes />,
  //       meta: {
  //         title: 'explorer_6',
  //         isHidden: false,
  //         icon: <Icon component={ICON_VALIDATOR} />,
  //       },
  //     },
  //     {
  //       path: ':dynamic',
  //       index: true,
  //       element: <ValidatorsDetailNew />,
  //       meta: {
  //         title: 'explorer_6',
  //         isHidden: false,
  //         icon: <Icon component={ICON_VALIDATOR} />,
  //       },
  //     },
  //   ],
  // },
  /**
   *  国家/区 /countryRegion
   *  国家/区详情 /countryRegion/:dynamic
   */
  {
    path: `${ROUTER_PREFIX}/countryRegion`,
    children: [
      {
        path: '',
        index: true,
        element: <CountryRegion />,
        meta: {
          title: 'explorer_6',
          isHidden: false,
          icon: <Icon component={ICON_VALIDATOR} />,
        },
      },
      {
        path: ':dynamic',
        index: true,
        element: <CountryRegionDetail />,
        meta: {
          title: 'explorer_6',
          isHidden: false,
          icon: <Icon component={ICON_VALIDATOR} />,
        },
      },
    ],
  },
  /**
   *  提案节点 /proposal
   */
  // {
  //   path: `${ROUTER_PREFIX}/proposal`,
  //   children: [
  //     {
  //       path: '',
  //       index: true,
  //       element: <Proposal />,
  //       meta: {
  //         title: 'explorer_6',
  //         isHidden: false,
  //         icon: <Icon component={ICON_VALIDATOR} />,
  //       },
  //     },
  //     {
  //       path: ':id',
  //       index: true,
  //       element: <ProposalDetail />,
  //       meta: {
  //         title: 'explorer_6',
  //         isHidden: false,
  //         icon: <Icon component={ICON_VALIDATOR} />,
  //       },
  //     },
  //   ],
  // },
  /**
   *  地址公示 /proposal
   */
  {
    path: `${ROUTER_PREFIX}/addressPublicity`,
    children: [
      {
        path: '',
        index: true,
        element: <AddressPublicity />,
        meta: {
          title: 'explorer_6',
          isHidden: false,
          icon: <Icon component={ICON_VALIDATOR} />,
        },
      },
    ],
  },
]

export const allRoutes: RouteObjectWithMeta[] = [
  {
    path: '/',
    element: <LanguageLayout />,
    meta: {
      // 首页
      title: 'explorer_335',
      isHidden: true,
      icon: <Icon component={ICON_HOME} />,
    },
    children: [
      {
        path: '/',
        element: <Navigate to={`/${langRouterLangMap[i18nConfig.defaultLang]}/home`} replace />,
      },
      {
        path: ROUTER_PREFIX,
        element: <Navigate to={`/${langRouterLangMap[i18nConfig.defaultLang]}/home`} replace />,
      },
      {
        path: `${ROUTER_PREFIX}/home`,
        element: (
          <UserHomeProvider>
            <HomePage />
          </UserHomeProvider>
        ),
        meta: {
          // 首页
          title: 'explorer_335',
          isHidden: true,
          icon: <Icon component={ICON_HOME} />,
        },
      },
      ...appRoutes,
    ],
  },
]
